import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/animations.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

// 👉 Import des contextes
import { SidebarProvider } from './context/SidebarContext';
import { DashboardProvider } from './context/DashboardContext';

// Patch ResizeObserver to prevent "loop completed with undelivered notifications" error
// This is a known benign error with ReactFlow NodeResizer
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to batch updates and prevent loop errors
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore ResizeObserver errors
        }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Chargement...</div>}>
      <SidebarProvider>
        <DashboardProvider>
          <App />
        </DashboardProvider>
      </SidebarProvider>
    </Suspense>
  </React.StrictMode>
);

// Si tu veux mesurer les performances de l'app :
reportWebVitals();

